import React from 'react';

import styled, { css } from 'styled-components';

import Link from 'components/Link';

import { pushAddAccountEvent, pushLoginEvent } from 'utils/dataLayerUtils';

const PillButton = styled(Link)<{ $type?: string }>`
  ${({ theme }) => css`
    color: ${theme.colors.white};
    text-decoration: none;
    padding: 0.15rem 1rem;
    border-radius: 5rem;
    font-family: ${theme.fonts.default};
    cursor: pointer;
  `}

  ${({ theme, $type }) =>
    $type === 'primary'
      ? css`
          background-color: ${theme.colors.primaryRed};
          font-size: 0.8125rem;
          text-transform: uppercase;
          font-weight: 600;
          &:hover {
            background-color: ${theme.colors.apple};
          }
        `
      : css`
          font-size: 0.875rem;
          &:hover {
            background-color: ${theme.colors.hoverGray};
          }
        `}
`;

interface CtaButtonProps {
  text?: string;
  link?: string;
  specialBehavior?: string;
  target?: string;
}

const SuperNavButton: React.FC<CtaButtonProps> = ({ text, link, specialBehavior, target }) => {
  const type = specialBehavior === 'open_an_account' ? 'primary' : 'secondary';

  const handleClick = (text?: string) => {
    if (text) {
      pushAddAccountEvent(text, { interaction_type: 'click', interaction_value: text });
      pushLoginEvent(text, 'click supernav');
    }
  };

  return (
    <PillButton
      to={link}
      $type={type}
      target={target}
      onClick={() => handleClick(text)}
      data-testid='supernav-button'
    >
      {text}
    </PillButton>
  );
};

export default SuperNavButton;
